module.exports = __webpack_public_path__ + "img/179-afe888.png";